import React from 'react';
import { Button, Col, Divider, Form, Layout, Row } from 'antd';
import styled from 'styled-components';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'src/stores';
import { InputField } from 'src/components/form';
import { loginAction } from 'src/stores/screens/auth/auth.action';

const { Content } = Layout;

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const validationSchema = yup.object().shape({
    email: yup.string().email().required('Email is required'),
    password: yup.string().required('Password is required').min(8),
  });

  const initialValues = {
    email: '',
    password: '',
  };

  const onLoginSuccess = (): void => {
    navigate('/homes');
  };

  const handleLogin = (value): void => {
    void dispatch(loginAction({ data: value, callback: onLoginSuccess }));
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues,
    onSubmit: value => {
      handleLogin(value);
    },
  });

  const { setFieldValue } = formik;

  return (
    <LoginScreenStyle>
      <Row>
        <Col span={24}>
          <Form name="login" className="login-form" onFinish={() => formik.handleSubmit()}>
            <InputField
              field={formik.getFieldProps('email')}
              setFieldValue={setFieldValue}
              className="form-control form-email"
              inputProps={{
                size: 'middle',
                prefix: <UserOutlined className="site-form-item-icon" />,
                placeholder: 'Email',
              }}
              error={formik.errors.email}
              touched={formik.touched.email}
            />

            <InputField
              field={formik.getFieldProps('password')}
              setFieldValue={setFieldValue}
              className="form-control form-email"
              inputProps={{
                size: 'middle',
                prefix: <LockOutlined className="site-form-item-icon" />,
                placeholder: 'Password',
              }}
              error={formik.errors.password}
              touched={formik.touched.password}
            />

            <Button className="btn-submit" htmlType="submit" type="primary">
              Login
            </Button>
          </Form>
          <Divider />
        </Col>
      </Row>
    </LoginScreenStyle>
  );
};

export default LoginScreen;

const LoginScreenStyle = styled(Content)`
  height: 100%;
  width: 100%;
  min-width: 400px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .btn-submit {
    width: 100%;
  }
`;
